import logo from './logo.svg';
import './App.scss';
import Routes from "./Routes";
import React from 'react';
import './App.scss';



function App() {
  return <Routes />
}

export default App;
